











































































import AbstractFieldComponentFactory from '@/classes/field-components/AbstractFieldComponentFactory';
import Vue from 'vue';
import {
  Component, InjectReactive, Watch, Prop,
} from 'vue-property-decorator';
import { Action, State } from 'vuex-class';
import TextFieldFactory from '@/classes/field-components/TextFieldFactory';
import TabbedDynamicForm from '@/components/FormBuilder/TabbedDynamicForm.vue';
import { CrudOperation } from '@/types/CrudOperation';
import { FieldComponent } from '@/types/FieldComponent';
import ObjectFieldFactory from '@/classes/field-components/ObjectFieldFactory';
import EntityCrud from '@/classes/EntityCrud';
import ListObjectFieldFactory from '@/classes/field-components/ListObjectFieldFactory';
import NumberFieldFactory from '@/classes/field-components/NumberFieldFactory';
import FieldCollectionFactory from '@/classes/field-components/FieldCollectionFactory';
import DateFieldFactory from '@/classes/field-components/DateFieldFactory';
import PimcoreEntityIntrospection from '@/classes/graphql-introspection/PimcoreEntityIntrospection';
import MediaFieldFactory from '@/classes/field-components/MediaFieldFactory';
import BooleanField from '@/classes/field-components/BooleanField';
import GraphQLFieldsExtractor from '@/classes/graphql-introspection/GraphQLFieldsExtractor';
import PimcoreSystemFieldsExcluder from '@/classes/graphql-introspection/PimcoreSystemFieldsExcluder';

import { folderIds } from '@/utils/config';

@Component({
  components: {
    TabbedDynamicForm,
  },
})
export default class FormFactory extends Vue {
  factory!: AbstractFieldComponentFactory;

  entityCrud!: EntityCrud;

  fieldComponents: FieldComponent[] = [];

  loading = false;

  isPreview = false;

  @Prop({ default: false })
  isModalShown!: boolean;

  @Prop({ default: () => ({}) })
  entityData!: any;

  @State('operation', { namespace: 'entity' })
  operation!: CrudOperation;

  @Prop() pimcoreIntrospection!: PimcoreEntityIntrospection;

  get fields() {
    return this.isReadOperation ? this.pimcoreIntrospection.queryFields : this.mutationFields;
  }

  get mutationFields() {
    return this.pimcoreIntrospection.queryFields.filter((qf) => this.pimcoreIntrospection.mutationFields.findIndex((mf) => mf.name === qf.name) >= 0);
  }

  get isReadOperation() {
    return this.operation === CrudOperation.read;
  }

  get isCreateOperation() {
    return this.operation === CrudOperation.create;
  }

  get isUpdateOperation() {
    return this.operation === CrudOperation.update;
  }

  get isPreviewOperation() {
    return this.operation === CrudOperation.preview;
  }

  get supportedFields() {
    return this.fields.filter((f) => this.factory?.anyFactorySupport(f)) || [];
  }

  get entity() {
    return this.$route.params.title;
  }

  get entityId() {
    return this?.entityData?.id || 0;
  }

  saveToLocalStorage(data: any) {
    const formData = localStorage.getItem('formData')
      ? JSON.parse(String(localStorage.getItem('formData')))
      : {};
    localStorage.setItem('formData', JSON.stringify({ ...formData, ...data }));
  }

  get cardTitle() {
    const entityName = this.$tc(this.entity, 2).toLocaleLowerCase();
    if (this.isPreview) {
      const previewHeader = this.$t('preview');
      return `${previewHeader} ${entityName}`;
    }
    const capitalizedOperation = `${this.operation[0].toUpperCase()}${this.operation.slice(1)}`;
    return `${this.$tc(capitalizedOperation)} ${entityName}`;
  }

  created() {
    const objectComponentParams: ConstructorParameters<typeof ObjectFieldFactory> = [
      this.pimcoreIntrospection.queries,
      new GraphQLFieldsExtractor(new PimcoreSystemFieldsExcluder()),
    ];

    const scalarFactories = [
      new DateFieldFactory(),
      new NumberFieldFactory(),
      new BooleanField(),
      new TextFieldFactory(),
      new ObjectFieldFactory(...objectComponentParams),
      new ListObjectFieldFactory(...objectComponentParams),
    ];

    const componentsFactroies = [
      new FieldCollectionFactory(new AbstractFieldComponentFactory(scalarFactories)),
      new MediaFieldFactory(),
      ...scalarFactories,
    ];
    this.factory = new AbstractFieldComponentFactory(componentsFactroies);
    this.entityCrud = new EntityCrud(this.pimcoreIntrospection.entity, this.$apollo);
  }

  beforeMount() {
    this.createComponents();
    this.$bus.$on('preview', this.onPreview);
  }

  @Action('toggleEntityModal', { namespace: 'entity' })
  toggleEntityModal: any;

  @Watch('entityId')
  onChangeEntityId() {
    this.createComponents();
  }

  @Watch('fields')
  onChangeEntity() {
    this.createComponents();
  }

  async createComponents() {
    let entityValues = {};
    if (this.isReadOperation || this.isUpdateOperation) {
      entityValues = this.entityData;
    }

    try {
      this.fieldComponents = await this.factory.createComponentsFromFields(this.fields, entityValues);
    } catch (e) {
      console.log(e);
    }
  }

  tryOnSubmitAction(formData: Record<string, any>) {
    const { value: legal_name }: any = this.fieldComponents.find((i) => i.name === 'legal_name') || { value: null };
    const { value: contract_email }: any = this.fieldComponents.find((i) => i.name === 'contract_email') || { value: null };
    if (this.operation === CrudOperation.read || this.operation === CrudOperation.delete) {
      throw new Error('Wrong operation');
    }

    if (this.pimcoreIntrospection?.entity === 'Supplier') {
      if ((!formData.legal_name && !legal_name) || (!formData.contract_email && !contract_email)) {
        this.$bus.$emit('notification', 'Обязательные поля: Юр. имя, Электронная почта из контракта', 'error');
        return null;
      }
    }

    if (this.operation === CrudOperation.update) {
      return this.entityCrud.update(this.entityId, formData);
    }

    const folderId = folderIds[this.pimcoreIntrospection.entity];
    if (!folderId) {
      this.$bus.$emit('notification', `При создании сущности ${this.$t(this.entity)} возникла ошибка: не указана директория pimcore`, 'error');
      return null;
    }

    return this.entityCrud.create({
      input: formData,
      key: `${this.$t(this.pimcoreIntrospection.entity)} (${Date.now()})`,
      folderId,
    });
  }

  formattedLegalNameFM(formData: any) {
    if (formData?.Contract?.items?.ContractHR?.length) {
      const new_contracts: any[] = [];
      formData.Contract.items.ContractHR.forEach((i: any) => {
        if (i.legal_name_FM) {
          new_contracts.push({
            ...i,
            legal_name_FM: {
              id: i.legal_name_FM.id,
              type: 'object',
            },
          });
        } else {
          new_contracts.push(i);
        }
      });
      formData.Contract.items.ContractHR = new_contracts;
    }
    return formData;
  }

  async onSubmit(formData: Record<string, any>) {
    this.loading = true;
    try {
      formData = this.formattedLegalNameFM(formData);
      const resp: any = await this.tryOnSubmitAction(formData);
      if (resp?.success === true) {
        this.toggleEntityModal(false);
        this.$bus.$emit('notification', 'Операция выполнена', 'success');
        this.$bus.$emit('entity-refetch');
      } else {
        console.error(resp);
      }
    } catch (e) {
      this.$bus.$emit('notification', 'Не удалось выполнить операцию', 'warning');
      console.log(e);
    } finally {
      this.loading = false;
    }
  }

  onPreview(value: boolean) {
    this.isPreview = value;
  }
}
